<template>
    <el-form >
        <el-form-item label="关联账号：" style="margin-left: 20px">
            <el-tag v-if="relationAccounts.length>4">...{{relationAccounts.length}}</el-tag>
            <el-button type="primary" icon="el-icon-circle-plus-outline" size="mini" @click="showRelation=true">
                关联账号
            </el-button>
            <template>
                <el-table
                        :data="relationAccounts"
                        border
                        style="width: 80%">
                    <el-table-column
                            prop="user_id"
                            label="用户ID">
                    </el-table-column>
                    <el-table-column
                            prop="username"
                            label="用户名">
                    </el-table-column>
                    <el-table-column
                            prop="real_name"
                            label="真实姓名">
                    </el-table-column>
                    <el-table-column
                            prop="hostName"
                            label="已授权设备" width="150px">
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="100">
                        <template slot-scope="scope">
                            <el-button style="width: 30%" v-if="scope.row.hostName != null" @click="DeleteUserDeviceId(scope.row.user_id)" type="text" size="small">撤销已授权设备</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
            <relation-dialog ref="account" service="division" :key="customerId" :title="'关联账号'"
                                :customerId="$route.query['id']"
                             @handleClose="closeRelationDialog" @relationAccount="relationAccount"
                             :is-show="showRelation"></relation-dialog>
        </el-form-item>
    </el-form>
</template>

<style scoped>
    .app-main .main-bd .el-row {
        padding: 10px 0;
    }
</style>

<script>

import RelationDialog from "~/views/customer/dialog/relationDialog.vue";
import AccountService from "~/services/CustomerAccounts";
export default {
    components: {
        RelationDialog,
    },
    created: function () {
        AccountService.getAccounts({
            customer_id: this.$route.query['id'],
            service: 'division',
        }).then(res => {
            if (res.data) {
                this.relationAccounts = [];
                this.relationAccounts = res.data;
                this.loading = false;
                //this.emit();
            }
        })
    },
    props: {
        customerId: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            input_size:'mini',
            subjects:[],
            relationAccounts: [],
            configUsed:false,
            formLabelWidth:'120px',
            multipleSelection: [],
            formInline: {
                user: '',
                region: ''
            },
            showRelation: false,
            showIsAlreadyRelation:false
        };
    },

    methods:{
        DeleteUserDeviceId(uid) {
            this.$confirm("此操作将撤销在其他客户端的访问权限！", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                AccountService.deleteUserDeviceId({
                    uid: uid
                }).then(res => {
                    if (res.code == 0) {

                        //重新请求列表
                        AccountService.getAccounts({
                            customer_id: this.$route.query['id'],
                            service: 'division',
                        }).then(res => {
                            if (res.data) {
                                this.relationAccounts = res.data;
                                this.$message({
                                    message: "撤销成功!",
                                    type: "success"
                                });
                            }
                        })
                    }
                })
            }).catch(() => {
            });
        },
        closeRelationDialog(show) {
            this.showRelation = show;
            this.showIsAlreadyRelation = show;
        },
        /**
         * 关联账号
         * */
        relationAccount(data) {

            // this.relationAccounts = data;
            //重新请求列表
            AccountService.getAccounts({
                customer_id: this.$route.query['id'],
                service: 'division',
            }).then(res => {
                if (res.data) {
                   // this.$set(this,'relationAccounts',res.data);
                    this.relationAccounts = res.data;
                }else{
                    this.relationAccounts = [];
                }
            })

        },
        onSubmit() {
            console.log('submit!');
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },

        handleSubmitLimitConfigure(){
            this.$emit('handleSubmitLimitConfigure',this.form);
        },

    }
}
</script>




// WEBPACK FOOTER //
// src/views/order/division/AccountSettings.vue